import { authApiHandler } from '../services/authApi'
import type { AuthConfig, GetTokensForContactResult } from '../types/types'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'
import { AccessTokenData } from '../types/tokenTypes'

export default (config: AuthConfig, cookieHeader?: string) => {
  const cookies = cookieHandler(cookieHeader)
  const token = tokenHandler(config)
  const authApi = authApiHandler(config)

  return async (contactId: number): Promise<GetTokensForContactResult | null> => {
    const provider = cookies.getProvider()
    const idToken = cookies.getIdToken()
    const refreshToken = cookies.getRefreshToken()

    const isValidIdToken = token.isValidToken(idToken)

    if (!isValidIdToken) {
      if (!refreshToken) {
        // cookies.clearTokens();
        return null
      }

      if (!provider) {
        // cookies.clearTokens();
        return null
      }

      const tokens = await authApi.refreshTokens(refreshToken, provider, contactId)
      if (!tokens) {
        // cookies.clearTokens();
        return null
      }

      const newContactId =
        token.getToken<AccessTokenData>(tokens.micrositeToken)?.contact?.contact_id ?? 0

      //   cookies.setIdToken(tokens.idToken, isPunchout);
      //   cookies.setRefreshToken(tokens.refreshToken, isPunchout);
      //   cookies.setAccessToken(tokens.micrositeToken, isPunchout);
      //   cookies.setContactId(newContactId, isPunchout);

      if (newContactId === 0) {
        return null
      }

      return tokens
    }

    const accessToken = await authApi.getAccessToken(idToken, contactId)

    if (!accessToken) {
      // cookies.clearTokens();
      return null
    }

    const newContactId = token.getToken<AccessTokenData>(accessToken)?.contact?.contact_id ?? 0

    // cookies.setAccessToken(accessToken, isPunchout);
    // cookies.setContactId(newContactId, isPunchout);

    if (newContactId === 0) {
      return null
    }

    return {
      idToken: null,
      refreshToken: null,
      micrositeToken: accessToken,
    }
  }
}
